import React, { useContext, useEffect, useState } from 'react';
import styles from './ChargerItem.module.css';
import { FaChargingStation } from 'react-icons/fa';
import { IoLocationSharp } from "react-icons/io5";
import { TbChargingPile } from "react-icons/tb";
import { BreathAPIs } from '../../../../../../APIs/BreathAPIs';
import { BookingsContext } from '../../../BookingContext';
// import { PiPlugsConnectedBold } from "react-icons/pi";
import { Tooltip } from 'antd';
import { Modal } from 'antd';

import { PiPlugChargingFill } from "react-icons/pi";
import { AiFillThunderbolt } from "react-icons/ai";
import { TbPlugConnected } from "react-icons/tb";
import { PiPlugsConnectedFill } from "react-icons/pi";
import { PiPlugsConnectedBold } from "react-icons/pi";
import { PiPlugsConnected } from "react-icons/pi";
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { useWebSocket } from '../../../../../../Utils/WebSocketContext';
import { HiRefresh } from "react-icons/hi";
import { toast } from 'react-toastify';
import RateBreakDownAutoReload from '../../RateBreakDownAutoReload';

const ChargerItem = ({ stationVal, locationData, makeToast, handleNewBooking, setIsSessionFormShow, isSessionFormShow, setSelectedChargerForNonRes, onSlotClick, isAutoPayEnabled, timeFormatAmPm, isGuest }) => {
    const [station, setStation] = useState(stationVal);
    // console.log("Locaition Data", locationData)
    // console.log("charger item station data before: ", stationVal)
    const navigate = useNavigate();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const webSocket = useWebSocket();
    const [eventType, setEventType] = useState("");
    const [connectorStatus, setConnectorStatus] = useState(() =>
        stationVal.reduce((statusMap, connector) => {
            statusMap[connector.connectorID] = connector.status;
            return statusMap;
        }, {})
);

    const [refreshing, setRefreshing] = useState(false);

    const [selectedConnectorForAutopay, setSelectedConnectorForAutoPay] = useState(null)

    useEffect(() => {setStation(stationVal)}, [stationVal])

    const getConnectorStatus = (connector) => connectorStatus[connector?.connectorID] ?? connector.status;

    const isConnectorInUse = (connector) => {
        const status = getConnectorStatus(connector);
        return !(status === 'Preparing' || status === 'Available') || checkActiveBookings(connector);
    }

    const [rateBreakdownModal, setRateBreakdownModal] = useState(false);
    // useEffect(() => {
    //     if(isAutoPayEnabled){
    //         BreathAPIs.createAutoPayNonResBooking(connector).then(res => {
    //             console.log("auto pay status: ", res)
    //         })
    //     }
    // }, [isAutoPayEnabled])

    useEffect(() => {
        setConnectorStatus(
            station.reduce((statusMap, connector) => {
            statusMap[connector.connectorID] = connector.status;
            return statusMap;
        }, {})
        )
    }, [station])

    const handleMakeToast = (type, text) => {
        if (makeToast) {
            makeToast(type, text);
        }
    };

    function checkActiveBookings(connector) {
        const currentTime = new Date();
        let status = false;
        if (connector.bookedSlots && connector.bookedSlots.length === 0) {
            return false;
        }
        connector.bookedSlots && connector.bookedSlots.forEach(slot => {
            if (currentTime >= slot.start && currentTime <= slot.end) {
                status = true;
            }
        });
        return status;
    }

    const { userBookings } = useContext(BookingsContext);

    useEffect(()=>{
        if (!webSocket) {
          return;
        }
        console.log("WebSocket connection established for BookingFormNonRes component.")
        const handleMessage = (event) => {
            const payload = JSON.parse(event.data);
            setEventType(payload.type);
            // console.log("WebSocket message received: ", payload, station);
            if (payload.type === "chargestation.connector_status.updated") {
              payload.data.connectors.forEach((updatedConnector) => {
                station.forEach(connector => {
                  if (connector.connectorID === updatedConnector.meta_data.breatheConnectorId) {
                    connector.status = updatedConnector.status;
                    setConnectorStatus(prevStatus => ({
                      ...prevStatus,
                      [updatedConnector.meta_data.breatheConnectorId]: updatedConnector.status
                    }))
                  }
              });
              setSelectedConnectorForAutoPay(prevConnector => {
                if (prevConnector && prevConnector.connectorID === updatedConnector.meta_data.breatheConnectorId) {
                  return { ...prevConnector, status: updatedConnector.status };
                }
                return prevConnector;
              })
            })
          }
        };
        webSocket.addEventListener('message', handleMessage);
        return () => {
          webSocket.removeEventListener('message', handleMessage);
        };
      },[webSocket, station])

    const checkSlotTaken = (time) => {
        let selectedBookings = [];

        const startTimeChk = new Date(time);
        startTimeChk.setMinutes(startTimeChk.getMinutes() - 15)

        const endDateTimeChk = new Date(time);
        endDateTimeChk.setMinutes(endDateTimeChk.getMinutes() + 15)



        for (let booking of userBookings) {
          if (
            (
                (new Date(booking.startTime).getTime() <= startTimeChk.getTime() && startTimeChk.getTime() < new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime()) ||
                (new Date(booking.startTime).getTime() < endDateTimeChk.getTime() && endDateTimeChk.getTime() <= new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime()) ||
                (startTimeChk.getTime() <= new Date(booking.startTime).getTime() && new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime() <= endDateTimeChk.getTime())
            )
            // && (userID === booking?.user?._id)
          ) {
            // console.log(booking)
            selectedBookings.push(booking);
          }
        }


        if (selectedBookings?.length) {
            const tenMinutesBeforeEnd = Date.now() + 11 * 60 * 1000;
        
            const result = selectedBookings.find(booking => 
                booking.endTime && new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime() > tenMinutesBeforeEnd
            );

            return result || false;


        }

        return false;

    }



    const makeBooking = async (connectorNum) => {
        // setIsSessionFormShow(!isSessionFormShow)
        let selectedConnectorData = station.find(connector => connector.connectorNumber === connectorNum);
        selectedConnectorData.status = getConnectorStatus(selectedConnectorData);
        console.log("selected connector data: ", selectedConnectorData)
        setSelectedChargerForNonRes(selectedConnectorData)
    }

    const handleInitiateBooking = async (connector) => {
        // Guests must always go through the booking form so the guest payment
        // hold modal can run - the autopay path below bypasses it entirely and
        // would rely on the shared pool account's wallet/autopay instead.
        if (isAutoPayEnabled && !isGuest) {
            const checkResult = checkSlotTaken(new Date());
        if (checkResult !== false) {
            const startTime = new Date(checkResult?.startTime).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: timeFormatAmPm
            });

            const endTime = new Date(checkResult?.endTime).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: timeFormatAmPm
            });

            Modal.confirm({
                title: 'Confirm',
                content: <div style={{ marginLeft: '-32px' }}>
                    You have an existing booking from <b>{startTime}</b> to <b>{endTime}</b> {'Would you like to view booking?'}
                </div>,
                okText: 'Yes',
                cancelText: 'No',
                onOk() {
                    navigate("/bookingHist");
                },
                okButtonProps: { className: styles['confirm-ok-button'] },
                cancelButtonProps: { className: styles['confirm-cancel-button'] },
                onCancel() {
                    // console.log('Cancelled');
                },

            });
            return;
        }
        if(locationData.rateType === 'dynamic'){
            setRateBreakdownModal(true)
            return 
        }
            
            setIsSubmitting(true)

            try{
                let response = await BreathAPIs.createAutoPayNonResBooking(connector, new Date(), locationData.timezone);

            if (response.status === 200) {
                navigate('/bookingHist', { state: { bookingSuccess: true } });
            }
            setIsSubmitting(false)
            return
            }
            catch(error){
                // console.log("error in auto pay booking: ", error)
                handleMakeToast('error', 'Failed to Create Booking');
                setIsSubmitting(false)
                return 
            }
            
        }
        onSlotClick(new Date(), true, 'non-reservable');
        makeBooking(connector.connectorNumber)
    }

    // console.log("connector status: ", connectorStatus)
    // console.log("station data in charger item after: ", station)

    const fmtMaxDuration = (hours) => {
        if (hours === undefined || hours === null || isNaN(hours)) {
            return null;
        }
        const totalMinutes = Math.round(hours * 60);
        const h = Math.floor(totalMinutes / 60);
        const m = totalMinutes % 60;
        return m ? `${h}h ${m}m` : `${h}h`;
    }

    const fmtLastSessionEnd = (endTime) => {
        if (!endTime) {
            return null;
        }
        const d = new Date(endTime);
        return d.toLocaleDateString([], { month: 'short', day: 'numeric' }) + ' ' +
            d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: timeFormatAmPm });
    }

    const handleNonResTileRefresh = async () =>{
        setRefreshing(true);
        try{
            const response = await BreathAPIs.getCharger(station[0].id);
            console.log("response from refetch ap8i: ", response.data.connector)
            let tempstationVal = station
            tempstationVal = tempstationVal.map(connector => {
                const updatedConnector = response.data.connector.find(c => c._id === connector.connectorID);
                return updatedConnector ? { ...connector, status: updatedConnector.status } : connector;
            });
            console.log("temp station val: before setting state: ", tempstationVal)
            setStation(tempstationVal);
        }catch(error){
            console.log("error in refreshing non res tile: ", error)
            toast.error("Failed to refresh. Please try again.")
        }finally{
            setRefreshing(false);
        }
        
    }

    return (
        // className={`${styles['charger-item']} ${(checkActiveBookings() || !((station.status == 'Preparing' || station.status == 'Available'))) ? styles['disable'] : ''}`}
        <div className={`${styles['charger-item']}`}>
            {/* <TbChargingPile className={styles['background-image']} /> */}
            <div className={styles['content']}>
                <div className={styles['top-panel']}>
                    <div className={styles['sub-top-panel']}>
                        <div>
                            {/* {console.log("station data: ", station)} */}
                            {

                                station.map((connector) => {
                                    const status = getConnectorStatus(connector);
                                    if (station.length > 1) {
                                        if (status === 'Available') {
                                            return (
                                                <div className={`${styles['statusPill']}`}>#{connector.connectorNumber}
                                                    <span>{status}</span>
                                                </div>
                                            )
                                        }
                                        if (status !== 'Available') {
                                            if (status === 'Preparing') {
                                                return (

                                                    <div className={`${styles['statusPill']} ${styles.preparing}`}>#{connector.connectorNumber}
                                                        <span>{status}</span>
                                                    </div>
                                                )
                                            } else if (status === "Charging") {
                                                return (
                                                    <div className={`${styles['statusPill']} ${styles.charging}`}>#{connector.connectorNumber}
                                                        <span>{status}</span>
                                                    </div>
                                                )
                                            } else if (status === "Finishing") {
                                                return (
                                                    <div className={`${styles['statusPill']} ${styles.finishing}`}>#{connector.connectorNumber}
                                                        <span>{status}</span>
                                                    </div>
                                                )
                                            } else if (status === "SuspendedEV") {
                                                return (
                                                    <div className={`${styles['statusPill']} ${styles.suspendedEV}`}>#{connector.connectorNumber}
                                                        <span>Standby</span>
                                                    </div>
                                                )
                                            }
                                        }
                                    } else {
                                        if (status === 'Available') {
                                            return (
                                                <div>
                                                    <span className={`${styles['statusPill']} `}>{status}</span>
                                                </div>
                                            )
                                        } else if (status === "Preparing") {
                                            return (
                                                <div>
                                                    <span className={`${styles['statusPill']} ${styles.preparing}`}>{status}</span>
                                                </div>
                                            )
                                        } else if (status === "Charging") {
                                            return (
                                                <div>
                                                    <span className={`${styles['statusPill']} ${styles.charging}`}>{status}</span>
                                                </div>
                                            )
                                        } else if (status === "Finishing") {
                                            return (
                                                <div>
                                                    <span className={`${styles['statusPill']} ${styles.finishing}`}>{status}</span>
                                                </div>
                                            )
                                        } else if (status === "SuspendedEV") {
                                            return (
                                                <div>
                                                    <span className={`${styles['statusPill']} ${styles.suspendedEV}`}>Standby</span>
                                                </div>
                                            )
                                        }
                                    }
                                }

                                )
                            }
                        </div>
                        {/* <div>
                            <HiRefresh 
                            onClick={()=>handleNonResTileRefresh()}/>
                        </div> */}
                    </div>
                    <div>
                        <div className={styles['refresht-title-parent-div']}>
                            <div className={styles['refresh-icon-div']}>
                                <HiRefresh className={refreshing ? styles["spin"] : ""}
                                onClick={()=>handleNonResTileRefresh()}/>
                            </div>
                            <div className={styles['content-title']}>{station[0].title}</div>
                        </div>
                        <div className={styles['location-name']}><IoLocationSharp />{locationData?.locationName}</div>
                        {/* <div className={`${styles['charger-status']} ${styles[station.status]}`}>{station.status}</div> */}
                        {fmtMaxDuration(locationData?.maxChargeDuration) &&
                            <div className={styles['meta-info']}>Max duration: {fmtMaxDuration(locationData?.maxChargeDuration)}</div>
                        }
                        {!station.some(isConnectorInUse) && fmtLastSessionEnd(station[0]?.lastSessionEndTime) &&
                            <div className={styles['meta-info']}>Last Used: {fmtLastSessionEnd(station[0]?.lastSessionEndTime)}</div>
                        }
                    </div>
                </div>
                {
                    station.every(connector => getConnectorStatus(connector) === 'Preparing') ?
                <div className={styles['instruction']}>
                    Please ensure the connector is plugged-in to your vehicle before initiating the session.
                </div> 
                :(
                    station.every(connector => getConnectorStatus(connector) === 'Available') ?
                    <div className={styles['instruction']}>
                    Press refresh once plugged-in to vehicle.
                </div> :
                <></>
            )
                }


                <dev className={styles['bottom-panel-container']}>
                {
                    station.map(connector => {
                         const status = getConnectorStatus(connector);
                        return (
                            <div className={styles['bottom-panel']}>
                                <div className={styles['bottom-info']}>
                                    <Tooltip
                                        color={'#18365E'}
                                        placement="top"
                                        title={`Connector Type`}
                                    >
                                        <PiPlugChargingFill /> {connector.connectorType}
                                    </Tooltip>

                                    <Tooltip
                                        color={'#18365E'}
                                        placement="top"
                                        title={`Maximum power`}
                                    >
                                        <AiFillThunderbolt /> {connector.power} kW
                                    </Tooltip>
                                </div>

                    
                                {
                                
                                    (status == 'Preparing' || status == 'Available') ?
                                        <button disabled={
                                            (isSubmitting || 
                                            status == 'Available' || 
                                            checkActiveBookings(connector)) ? true : false} 
                                            onClick={() => {setSelectedConnectorForAutoPay(connector); handleInitiateBooking(connector); }}>
                                        {/* <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div> */}

                                        {isSubmitting ? <>Initiating {connector.noOfConnectorsInCharger !== 1 ? 
                                        <span style={{ "marginLeft": '8px' }}>  #{connector.connectorNumber}</span> : <></>}</> : 
                                        (checkActiveBookings(connector) ? <>In Use {connector.noOfConnectorsInCharger !== 1 ? 
                                        <span style={{ "marginLeft": '8px' }}>  #{connector.connectorNumber}</span> : <></>}</> : 
                                        (<>
                                            {
                                            status == 'Available' ?
                                            <>Plug-in to Vehicle {connector.noOfConnectorsInCharger !== 1 ? <span style={{ "marginLeft": '8px' }}>#{connector.connectorNumber}</span> : null}</> :
                                            <>Initiate {connector.noOfConnectorsInCharger !== 1 ? <span style={{ "marginLeft": '8px' }}>#{connector.connectorNumber}</span> : null}</>
                                            }
                                        </>))}
                                    </button>
                                    :
                                    <button disabled>In Use {connector.noOfConnectorsInCharger !== 1 ? <span style={{ "marginLeft": '8px' }}>  #{connector.connectorNumber}</span> : <></>}</button>

                                }
                    
                            </div>
                        ) 
                    })
                }
                </dev>

                {/* {console.log("station[0] val: ", station)} */}
                {/* <div className={styles['bottom-panel']}>
                    <div className={styles['bottom-info']}>
                        <Tooltip
                            color={'#18365E'}
                            placement="top"
                            title={`Connector Type`}
                        >
                            <PiPlugChargingFill /> {station[0].connectorType}
                        </Tooltip>

                        <Tooltip
                            color={'#18365E'}
                            placement="top"
                            title={`Maximum power`}
                        >
                            <AiFillThunderbolt /> {station[0].power} kW
                        </Tooltip>
                    </div>


                    {
                        station.map((connector) => {
                            const status = getConnectorStatus(connector);
                            return (
                                (status == 'Preparing' || status == 'Available') ?
                                    <button disabled={
                                        (isSubmitting || 
                                        status == 'Available' || 
                                        checkActiveBookings(connector)) ? true : false} 
                                        onClick={() => { handleInitiateBooking(connector) }}>
                                    

                                    {isSubmitting ? <>Initiating {connector.noOfConnectorsInCharger !== 1 ? 
                                    <span style={{ "marginLeft": '8px' }}>  #{connector.connectorNumber}</span> : <></>}</> : 
                                    (checkActiveBookings(connector) ? <>In Use {connector.noOfConnectorsInCharger !== 1 ? 
                                    <span style={{ "marginLeft": '8px' }}>  #{connector.connectorNumber}</span> : <></>}</> : 
                                    (<>
                                        {
                                        status == 'Available' ?
                                        <>Plug-in to Vehicle</> :
                                        <>Initiate {connector.noOfConnectorsInCharger !== 1 ? <span style={{ "marginLeft": '8px' }}>#{connector.connectorNumber}</span> : null}</>
                                         }
                                    </>))}
                                </button>
                                :
                                <button disabled>In Use {connector.noOfConnectorsInCharger !== 1 ? <span style={{ "marginLeft": '8px' }}>  #{connector.connectorNumber}</span> : <></>}</button>
                        )})


                    }
                </div> */}
                {selectedConnectorForAutopay && <Modal
                    title="Rate Breakdown"
                    open={rateBreakdownModal}
                    onCancel={() => {setRateBreakdownModal(false); setSelectedConnectorForAutoPay(null)}}
                    footer={null}
                    className={styles['rate-breakdown-modal']}
                >
                    <RateBreakDownAutoReload 
                    setIsSubmitting={setIsSubmitting}
                    isSubmitting={isSubmitting}
                    locationData={locationData}
                    selectedConnectorForAutopay={selectedConnectorForAutopay}
                    />
                </Modal>}
            </div>
        </div>
    )
};

// export default ChargerItem;

ChargerItem.propTypes = {
    isAutoPayEnabled: PropTypes.bool,
    timeFormatAmPm: PropTypes.bool,
}
const mapStateToProps = state => ({
    isAutoPayEnabled: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
    timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
    isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,
})
export default connect(mapStateToProps, {})(ChargerItem)